import { Routes } from "@angular/router";
import { ProductComponent } from "src/app/product/product/product.component";
import { WhishlistComponent } from "src/app/product/whishlist/whishlist.component";
import { ChooseReturnComponent } from "src/app/returnflow/choose-return/choose-return.component";
import { ReturnCompletedComponent } from "src/app/returnflow/return-completed/return-completed.component";
import { ReturnInfoComponent } from "src/app/returnflow/return-info/return-info.component";
import { ReturnReasonComponent } from "src/app/returnflow/return-reason/return-reason.component";
import { ReturnUserDataComponent } from "src/app/returnflow/return-user-data/return-user-data.component";
import { ReturnComponent } from "src/app/returns/returns/return/return.component";
import { ReturnsComponent } from "src/app/returns/returns/returns/returns.component";


export const RETURNS_ROUTES: Routes = [
    {
      path: 'returns', component: ReturnsComponent
    },
    {
      path: 'return/choose/:id', component: ChooseReturnComponent
    },
    {
      path: 'return/choose/reason/:orderUUID/:cartLineUUID', component: ReturnReasonComponent
    },
    {
      path: 'return/user/data/:orderUUID/:cartLineUUID', component: ReturnUserDataComponent
    },
    {
      path: 'return/info/:orderUUID/:cartLineUUID', component: ReturnInfoComponent
    },
    {
      path: 'return/completed', component: ReturnCompletedComponent
    },
    {
      path: 'return/:id', component: ReturnComponent
    },

]